import React, { Component } from "react"
import { Segment } from "semantic-ui-react"
import { Icon } from "semantic-ui-react"
import "./RechercheFiltre.css"
import BarreDeRecherche from "./BarreDeRecherche"
import FiltreDevis from "./FiltreDevis"

class RechercheFiltre  extends Component {

  constructor(props){
    super(props);
  }

  render() {
    const {prestations, style, onSearchChange, searchValue, children} = this.props;
    return (
      <Segment id="RechercheFiltreAndButton">
        <BarreDeRecherche prestations={prestations} style={style} onSearchChange={onSearchChange} searchValue={searchValue} />
        {
          children
        }
      </Segment>
    )
  }
}

export default RechercheFiltre



// WEBPACK FOOTER //
// ./src/components/Pro/Entete/RechercheFiltre.js